var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgServerError = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 430.493,
    viewBox: "0 0 800 430.493",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-368.866 -254.661)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.199,
    cy: 26.107,
    fill: "#090814",
    rx: 149.199,
    ry: 26.107,
    transform: "translate(368.866 481.453)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 191.906,
    cy: 26.107,
    fill: "#090814",
    rx: 191.906,
    ry: 26.107,
    transform: "translate(785.054 632.939)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M757.093 641.43a140 140 0 0 1-34.251-3.807l1.007-3.942c61.693 15.766 176.375-20.484 188.785-59.673l3.879 1.228c-10.783 34.054-95.197 66.194-159.42 66.194M701.142 559.64c-14.453-3.693-21.922-7.965-24.218-13.849-2.856-7.316 2.5-15.561 9.919-26.972 11.315-17.409 26.811-41.252 24.3-77.646-1.418-20.568-8.78-35.7-21.879-44.978-26.656-18.878-68.707-7.567-69.129-7.451l-1.085-3.921c1.8-.5 44.3-11.949 72.551 8.041 14.153 10.017 22.094 26.176 23.6 48.028 2.6 37.751-13.977 63.262-24.949 80.143-6.756 10.394-11.637 17.9-9.54 23.275 1.748 4.477 8.559 8.1 21.436 11.386Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "m953.007 592.272-20.655 34.927s-26.3 13.971-7.807 14.382 105.6 0 105.6 0 16.847 0-9.862-14.793l-19.389-37.478Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 348.044,
    height: 242.439,
    fill: "#e6e6e6",
    rx: 18.046,
    transform: "translate(801.887 355.38)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be1622",
    d: "M816.31 368.323h319.2a2.71 2.71 0 0 1 2.712 2.712v190.582a2.71 2.71 0 0 1-2.712 2.712h-319.2a2.71 2.71 0 0 1-2.712-2.712V371.035a2.71 2.71 0 0 1 2.712-2.712"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.055,
    cy: 2.055,
    r: 2.055,
    fill: "#f2f2f2",
    transform: "translate(973.854 360.516)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M1149.931 564.329v21.252a12.236 12.236 0 0 1-12.239 12.237H814.124a12.236 12.236 0 0 1-12.237-12.239v-21.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M1066.721 663.77v4.109H845.649v-3.288l.3-.822 5.449-14.793h210.8ZM1151.796 659.747c-.4 1.722-1.923 3.538-5.358 5.256-12.327 6.164-37.393-1.644-37.393-1.644s-19.313-3.287-19.313-11.917a15 15 0 0 1 1.693-1.007c5.183-2.742 22.367-9.508 52.837.286a12.7 12.7 0 0 1 5.792 3.8c1.234 1.443 2.203 3.276 1.742 5.226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M1151.797 659.747c-15.089 5.782-28.538 6.213-42.34-3.374-6.961-4.832-13.285-6.028-18.031-5.938 5.183-2.742 22.367-9.508 52.837.286a12.7 12.7 0 0 1 5.792 3.8c1.234 1.443 2.202 3.276 1.742 5.226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.721 663.77v4.109H845.649v-3.288l.3-.822Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be1622",
    d: "M612.971 334.908H411.138a6.086 6.086 0 0 1-6.079-6.079V260.74a6.086 6.086 0 0 1 6.079-6.079h201.833a6.086 6.086 0 0 1 6.079 6.079v68.088a6.086 6.086 0 0 1-6.079 6.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M436.671 272.899h53.498v6.079h-53.498z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.648,
    cy: 3.648,
    r: 3.648,
    fill: "#f2f2f2",
    transform: "translate(557.041 272.899)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.648,
    cy: 3.648,
    r: 3.648,
    fill: "#f2f2f2",
    transform: "translate(569.2 272.899)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.648,
    cy: 3.648,
    r: 3.648,
    fill: "#f2f2f2",
    transform: "translate(581.358 272.899)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M612.971 421.234H411.138a6.087 6.087 0 0 1-6.079-6.079v-68.089a6.086 6.086 0 0 1 6.079-6.079h201.833a6.086 6.086 0 0 1 6.079 6.079v68.088a6.086 6.086 0 0 1-6.079 6.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be1622",
    d: "M436.671 359.225h53.498v6.079h-53.498z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.648,
    cy: 3.648,
    r: 3.648,
    fill: "#be1622",
    transform: "translate(557.041 359.225)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.648,
    cy: 3.648,
    r: 3.648,
    fill: "#be1622",
    transform: "translate(569.2 359.225)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.648,
    cy: 3.648,
    r: 3.648,
    fill: "#be1622",
    transform: "translate(581.358 359.225)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M612.971 507.56H411.138a6.087 6.087 0 0 1-6.079-6.079v-68.089a6.086 6.086 0 0 1 6.079-6.079h201.833a6.086 6.086 0 0 1 6.079 6.079v68.089a6.086 6.086 0 0 1-6.079 6.079"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be1622",
    d: "M436.671 445.552h53.498v6.079h-53.498z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.648,
    cy: 3.648,
    r: 3.648,
    fill: "#be1622",
    transform: "translate(557.041 445.552)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.648,
    cy: 3.648,
    r: 3.648,
    fill: "#be1622",
    transform: "translate(569.2 445.552)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.648,
    cy: 3.648,
    r: 3.648,
    fill: "#be1622",
    transform: "translate(581.358 445.552)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M933.489 421.851h88.949V510.8h-88.949Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M977.963 429.263a37.06 37.06 0 0 1 37.063 37.062 37.06 37.06 0 1 1-74.11 1.2l-.015-1.2.015-1.038a37.06 37.06 0 0 1 37.047-36.024m.038 48.181-.471.026a3.706 3.706 0 0 0 0 7.361l.434.026.471-.026a3.706 3.706 0 0 0 0-7.361Zm-.037-32.362a3.706 3.706 0 0 0-3.68 3.272l-.026.434v20.25l.026.434a3.706 3.706 0 0 0 7.361 0l.026-.434v-20.25l-.026-.434a3.706 3.706 0 0 0-3.682-3.272Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgServerError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/server-error.6c979839.svg";